/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareTypeResponse,
    FareTypeResponseFromJSON,
    FareTypeResponseFromJSONTyped,
    FareTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareTypeResponseCriteriaResponse
 */
export interface FareTypeResponseCriteriaResponse {
    /**
     * 
     * @type {FareTypeResponse}
     * @memberof FareTypeResponseCriteriaResponse
     */
    value?: FareTypeResponse;
    /**
     * 
     * @type {boolean}
     * @memberof FareTypeResponseCriteriaResponse
     */
    exclude?: boolean;
}

export function FareTypeResponseCriteriaResponseFromJSON(json: any): FareTypeResponseCriteriaResponse {
    return FareTypeResponseCriteriaResponseFromJSONTyped(json, false);
}

export function FareTypeResponseCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypeResponseCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : FareTypeResponseFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function FareTypeResponseCriteriaResponseToJSON(value?: FareTypeResponseCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': FareTypeResponseToJSON(value.value),
        'exclude': value.exclude,
    };
}


